module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 87.aa16eb5c.png";